import { render, staticRenderFns } from "./PerfilAcessoListagem.vue?vue&type=template&id=47bcd9c9&scoped=true&"
import script from "./PerfilAcessoListagem.vue?vue&type=script&lang=js&"
export * from "./PerfilAcessoListagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bcd9c9",
  null
  
)

export default component.exports